import React from "react";
import { BeatLoader } from "react-spinners";

const LoadingComponent = ({
  wrapperStyle={ textAlign: "center"},
  loading = false,
  color = "var(--phoenix-emphasis-color)",
  size = 14,
}) => {
 
  return (
    <div style={wrapperStyle}>
      <BeatLoader loading={loading} color={color} size={size} />
    </div>
  );
};

export default LoadingComponent;
